import { useTheme } from '@mui/material/styles';
import {
  GENERAL_STATUS_MAP,
  GeneralStatus,
  StatusBadge
} from 'modules/status-badge';
import { getHoursAndMinutesLabel } from 'utils/date';
import { Reason } from '../types';
import { isEffectiveValueVisible, mapReasonTimeMismatchType } from '../utils';
import {
  ReasonCardContent,
  ReasonCardWrapper,
  ReasonInfo,
  ReasonInfoLabel,
  ReasonTypeText
} from './styledComponents';

export const ReasonCard = ({
  reason,
  isLastInGroup,
  onClick,
  testId = 'reason-card'
}: {
  reason: Reason;
  isLastInGroup: boolean;
  onClick: () => void;
  testId?: string;
}) => {
  const theme = useTheme();
  const {
    timeMismatchType,
    status,
    reportedReasonMinutes,
    effectiveReasonMinutes
  } = reason;

  const customSx = {
    borderBottomLeftRadius: 2,
    borderBottomRightRadius: 2,
    marginBottom: -1.5,
    [theme.breakpoints.up('sm')]: {
      marginBottom: -2.5
    }
  };

  const reportedMinutesLabel = getHoursAndMinutesLabel(
    Math.abs(reportedReasonMinutes)
  );
  const effectiveMinutesLabel = isEffectiveValueVisible(
    effectiveReasonMinutes,
    reportedReasonMinutes,
    status
  )
    ? getHoursAndMinutesLabel(Math.abs(effectiveReasonMinutes ?? 0))
    : undefined;

  return (
    <ReasonCardWrapper
      sx={isLastInGroup ? customSx : null}
      onClick={onClick}
      data-testid={testId}
    >
      <ReasonCardContent>
        <ReasonTypeText variant="body2">
          {mapReasonTimeMismatchType[timeMismatchType]()}
        </ReasonTypeText>
        <ReasonInfo>
          <ReasonInfoLabel variant="body2" crossed={!!effectiveMinutesLabel}>
            {reportedMinutesLabel}
          </ReasonInfoLabel>
          {effectiveMinutesLabel && (
            <ReasonInfoLabel
              variant="body2"
              sx={{
                color: 'primary.light'
              }}
            >
              {effectiveMinutesLabel}
            </ReasonInfoLabel>
          )}
          {status && status !== GeneralStatus.REPORTED && (
            <StatusBadge status={status} statusMap={GENERAL_STATUS_MAP} />
          )}
        </ReasonInfo>
      </ReasonCardContent>
    </ReasonCardWrapper>
  );
};
